export default __webpack_public_path__ + "static/media/project_cadefi.aa5323bd.png";